import React from 'react';
import {useTranslation} from 'react-i18next';
import Button from '../../acommon/Button';
import Modal from '../../acommon/Modal';
import {
  ButtonsWrapperWarningModal,
  ContainerWarningModal,
  DescriptionWarningModal,
  TitleWarningModal,
} from './styled';

type TaxesWarningModalProps = {
  isOpen: boolean;
  onSave: () => void;
  onClose: () => void;
  onDiscard: () => void;
};

function TaxesWarningModal({isOpen, onClose, onDiscard, onSave}: TaxesWarningModalProps) {
  const {t} = useTranslation();

  return (
    <Modal densed visible={isOpen} onClose={onClose}>
      <ContainerWarningModal>
        <TitleWarningModal>{t('warning_close_taxes_modal_title')}</TitleWarningModal>
        <DescriptionWarningModal>
          {t('warning_close_taxes_modal_description')}
        </DescriptionWarningModal>
        <ButtonsWrapperWarningModal>
          <Button label={t('save')} onClick={onSave} />
          <Button label={t('discard')} onClick={onDiscard} stroke />
        </ButtonsWrapperWarningModal>
      </ContainerWarningModal>
    </Modal>
  );
}

export {TaxesWarningModal};
